import apiClient from './apiClient';
import { ENDPOINTS } from '../config/modernApiConfig';

/**
 * A service for interacting with the audit log API.
 */
class AuditService {
    /**
     * Retrieves audit entries from the server with optional filtering and pagination.
     * @param {object} params - The query parameters for the request.
     * @returns {Promise<object>} The response from the API.
     */
    async getAuditEntries(params = {}) {
        try {
            const response = await apiClient.get(ENDPOINTS.GET_AUDIT_ENTRIES, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching audit entries:', error);
            throw error;
        }
    }
}

export const auditService = new AuditService(); 